<template>
  <div class="alert-wrapper">
    <v-alert
      v-if="!!browser"
      density="compact"
      icon="$warning"
      class="alert"
      :text="`For the best experience, use Chrome instead of ${browser} due to potential UI issues.`"></v-alert>
  </div>
</template>

<script>
export default {
  data () {
    return {
      browser: ''
    }
  },
  mounted () {
    this.checkBrowser()
  },
  methods: {
    checkBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('chrome') === -1 && (ua.indexOf('safari') !== -1 || ua.indexOf('firefox') !== -1)) {
        // Safari or Firefox detected
        this.browser = ua.indexOf('safari') !== -1 ? 'Safari' : 'Firefox'
      }
    }
  }
}
</script>

<style scoped>
.alert-wrapper {
  width: 100vw;
  margin-left: -40px;
}

.alert {
  font-size: 14px;
  border-radius: 0;
  background-color: #73E5A6;
  color: var(--white, #ffffff);
}
</style>
